import React, { useEffect, useState } from 'react'
import classes from "../../styles.module.css";
import { useNavigate } from 'react-router-dom';
import TitleSection from '../../../../common/TitleSection';
import { Helmet } from 'react-helmet';
import { FullWidthWiraaAds } from '../../../../common/Ads/FullWidthWiraaAds';
import styles from "../../../../ContentStyling.module.css";

const FeettoMiles = () => {
    const [inputValue, setInputValue] = useState();
    const [outputValue, setOutputValue] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        // Initialize Google Ads
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          console.error("AdSense run successfully");
        } catch (e) {
          console.error("AdSense error", e);
        }
      }, []);

      const convertFeetToMiles = () => {
        // Validate input: allow numbers, decimals, and optional minus sign
        if (!/^-?\d+(\.\d+)?$/.test(inputValue)) {
            setErrorMessage("Please enter a valid length in feet (e.g., 5280, 10000.5).");
            setOutputValue("");
            return;
        }

        setErrorMessage("");
        const feetValue = parseFloat(inputValue); // Convert input string to a number
        const mileValue = feetValue / 5280; // 1 mile = 5280 feet
        setOutputValue(mileValue.toFixed(6)); // Limit output to 6 decimal places
    };








      const handleClearBtn = () => {
        setInputValue("");
        setOutputValue("");
        setErrorMessage("");
      }

      const handleSwapClick = () => {
        navigate("/converters/miles-to-feet");
    };

        

  return (
    <div className={classes.page}>
      <Helmet>
                <title>Feet to Miles Converter - Wiraa tools</title>
                <meta name="description" content="Easily convert feet to miles using our online conversion tool. Accurate results with simple calculations for your length measurements. Try now!" />
        </Helmet>
    <div className={classes.container}>
      <TitleSection
        icon="https://cdn-icons-png.flaticon.com/128/570/570968.png"
        title="Feet To Miles Converter"
        subTitle="Effortlessly Convert Feet To Miles for Accurate Measurements"
      />
      <div className={classes.innerCon}>
        <div className={classes.inputCon}>
            <p className={classes.inputplaceholder}>Feet Value</p>
            <input value={inputValue} onChange={(e) => setInputValue(e.target.value)} className={classes.inputfield} placeholder='Enter feet value'/>
            {errorMessage && <p className={classes.errorMsg}>{errorMessage}</p>}
        </div>
        <div className={classes.btnCon}>
            <button className={classes.convertBtn} onClick={convertFeetToMiles}>Convert</button>
            <button className={classes.clearBtn} onClick={handleClearBtn}>Clear</button>
            <button className={classes.swapBtn} onClick={handleSwapClick}>Swap</button>
        </div>
        <div className={classes.outputCon}>
            <p className={classes.outputplaceholder}>Miles Value</p>
            <p className={classes.outputfield}>{outputValue}</p>
        </div>
      </div>
      <div className={classes.ads}>
        <FullWidthWiraaAds/>
     </div>
     <div className={styles.contentContainer}>
      <p>The Feet to Miles Converter is a practical tool for converting smaller distance measurements into long-distance formats. This tool is especially useful for athletes, engineers, land surveyors, and anyone dealing with geographical data.</p>
      <h3>What Are Feet and Miles?</h3>
      <p><b>Feet (ft):</b>An imperial unit used to measure shorter distances. Common in architecture, aviation, and everyday scenarios.</p>
      <p><b>Miles (mi): </b>A larger unit of length used mainly for measuring long distances, such as travel routes and geographical locations. <br />1 mile = 5,280 feet</p>
      <h3>Why Convert Feet to Miles?</h3>
      <ul>
        <li><b>Long-Distance Context:</b> Helps convert measurements to a more readable format when dealing with larger values.</li>
        <li><b>Standardization:</b> Ideal for official documents, maps, or distance planning.</li>
        <li><b>Improved Understanding:</b> Makes data easier to comprehend in transportation and fitness tracking.</li>
      </ul>
      <h3>How to Use the Feet to Miles Converter</h3>
      <ol>
        <li><b>Input Feet Value:</b> Type in your distance in feet.</li>
        <li><b>Click Convert:</b> Instantly see the result in miles.</li>
        <li><b>Apply the Result:</b> Use the conversion for travel estimations, sports data, or engineering plans.</li>
      </ol>
      <h3>Conversion Examples</h3>
      <ul>
        <li>5,280 ft → 1 mile</li>
        <li>10,560 ft → 2 miles</li>
        <li>26,400 ft → 5 miles</li>
        <li>52,800 ft → 10 miles</li>
      </ul>
      <h3>Benefits of Using the Feet to Miles Converter</h3>
      <ul>
        <li><b>Simple Interface:</b> Easy for anyone to use.</li>
        <li><b>Accurate Results:</b> No need for mental math.</li>
        <li><b>Widely Applicable:</b> Useful across industries like fitness, civil engineering, and logistics.</li>
      </ul>
     </div>
    </div>
   </div>
  )
}

export default FeettoMiles;
